import { render, staticRenderFns } from "./ReferrersData.vue?vue&type=template&id=a22197ee&scoped=true&"
import script from "./ReferrersData.vue?vue&type=script&lang=js&"
export * from "./ReferrersData.vue?vue&type=script&lang=js&"
import style0 from "./ReferrersData.vue?vue&type=style&index=0&id=a22197ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22197ee",
  null
  
)

export default component.exports